import React from 'react';
import PageHeader from '../components/PageHeader';
import { BarChartComponent, LineChartComponent, PieChartComponent } from '../components/CustomChart';
import { analyticsData } from '../data/dummyData';

const Reports = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Reports"
        description="Generate and view detailed reports"
        breadcrumbs={['Home', 'Reports']}
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <BarChartComponent
          data={analyticsData.monthlySales}
          dataKey="sales"
          title="Monthly Sales Report"
          xAxisKey="month"
        />
        <LineChartComponent
          data={analyticsData.customerGrowth}
          dataKey="customers"
          title="Customer Growth Report"
          xAxisKey="month"
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <BarChartComponent
          data={analyticsData.categoryRevenue}
          dataKey="revenue"
          title="Revenue Report"
          xAxisKey="category"
        />
        <PieChartComponent
          data={analyticsData.orderStatus}
          dataKey="value"
          title="Order Status Report"
        />
      </div>
    </div>
  );
};

export default Reports;
